/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Align_Center_Right_Justify_Center_PosInputs */



/**
* | output |
* | --- |
* | "Right Justify / Center Position" |
*
* @param {Align_Center_Right_Justify_Center_PosInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const align_center_right_justify_center_pos = /** @type {((inputs?: Align_Center_Right_Justify_Center_PosInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Align_Center_Right_Justify_Center_PosInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Justification Droite / Position Centree")
	if (locale === "de") return /** @type {LocalizedString} */ ("Rechtsbündig / Zentriert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Allineamento a destra / Posizione centrale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выравнивание по правому краю / Центрирование")
	if (locale === "es") return /** @type {LocalizedString} */ ("Justificar a la derecha / Posición centrada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("右对齐/居中")
	if (locale === "ja") return /** @type {LocalizedString} */ ("右揃え / 中央揃え")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दाईं ओर संरेखित करें / केंद्र में रखें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Justificar à direita / Posicionamento centralizado")
	return /** @type {LocalizedString} */ ("Right Justify / Center Position")
});